import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "../Components/layout/layout";
import Login from "../Components/auth/login";
import ForgotPassword from "../Components/auth/forgotPassword";
import UserManagement from "../Pages/userManagement/userManagement";
import Dashboard from "../Pages/dashboard/dashboard";
import ContentManagement from "../Pages/contentManagement/contentManagement";
import MatchManagement from "../Pages/matchManagement/matchManagement";
import PlanManagement from "../Pages/plansManagement/planManagement";
import Settings from "../Pages/settings/settings";
import AnalyticsAndReporting from "../Pages/analyticsReports/analytics&Reporting";
import PrivateRoute from "../Utils/privateRoute";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ViewUserManagement from "../Pages/userManagement/viewUserManagement";
import Notifications from "../Pages/notifications/notifications";
import { isAuthenticated } from "../Utils/authUtils";
import ViewMatchManagement from "../Pages/matchManagement/viewMatchManagement";
import LandingPage from "../landingPage/home";
import PlanHistory from "../Pages/planHistory/planHistory";
import PlanHistoryDetail from "../Pages/planHistory/planHistoryDetails";
import CampaignNotification from "../Pages/campaignNotification/campaignNotification";
import TermsAndConditions from "../Pages/footerPages/terms&condition";
import PrivacyPolicy from "../Pages/footerPages/privayPolicy";
import CommunityGuidelines from "../Pages/footerPages/communityGuidelines";
import EULA from "../Pages/footerPages/eula";
import Safety from "../Pages/footerPages/safety";

const RootRedirect = () => {
  try {
    if (isAuthenticated()) {
      return <Navigate to="/admin/dashboard" replace />;
    }
  } catch (error) {
    console.error('Error checking auth for redirect:', error);
  }

  return <Navigate to="/admin/login" replace />;
};

export default function AppRoutes() {
  return (
    <>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          pauseOnHover
          draggable
        />
        <Routes>
          {/* Landing page route */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Footer pages routes */}
          <Route path="terms&condition" element={<TermsAndConditions />} />
          <Route path="privacyPolicy" element={<PrivacyPolicy />}/>
          <Route path="communityGuidelines" element={<CommunityGuidelines />}/>
          <Route path="eula" element={<EULA />}/>
          <Route path="safety" element={<Safety />}/>

          {/* Admin routes */}
          <Route path="admin/login" element={<Login />} />
          <Route path="admin/forgotPassword" element={<ForgotPassword />} />

          <Route path="/admin" element={<Layout />}>
            <Route index element={<RootRedirect />} />

            <Route path="dashboard" element={<PrivateRoute component={Dashboard} />} />
            <Route path="userManagement" element={<PrivateRoute component={UserManagement} />} />
            <Route path="viewUserManagement/:id" element={<PrivateRoute component={ViewUserManagement} />} />
            <Route path="contentManagement" element={<PrivateRoute component={ContentManagement} />} />
            <Route path="matchManagement" element={<PrivateRoute component={MatchManagement} />} />
            <Route path="viewMatchManagement/:id" element={<PrivateRoute component={ViewMatchManagement} />} />
            <Route path="planManagement" element={<PrivateRoute component={PlanManagement} />} />
            <Route path="planHistory" element={<PrivateRoute component={PlanHistory} />} />
            <Route path="planHistoryDetail/:userId" element={<PrivateRoute component={PlanHistoryDetail} />} />
            <Route path="settings" element={<PrivateRoute component={Settings} />} />
            <Route path="notifications" element={<PrivateRoute component={Notifications} />} />
            <Route path="campaignNotification" element={<PrivateRoute component={CampaignNotification} />} />
            <Route path="analytics&Reporting" element={<PrivateRoute component={AnalyticsAndReporting} />} />
          </Route>

          <Route path="*" element={<RootRedirect />} />
        </Routes>
        <Routes>

        </Routes>
      </BrowserRouter>
    </>
  );
}
